import React, { useContext, useEffect } from 'react';
import { PetInterface } from 'types/pet';
import { useQuery } from 'react-query';
import { checkSpecialtyPet } from '../../components/pet-view-content/PetViewContent';
import loadArticles, { loadSpecialtyArticles } from '../../api/articleApi';
import { retryCount } from '../../util/reactQueryOptions';
import Articles from './Articles';

export const RenderArticles = ({
  petProfile,
  isMinLarge,
}: {
  petProfile: PetInterface;
  isMinLarge: boolean;
}) => {
  const isSpecialtyPet = checkSpecialtyPet(petProfile.petType.id);

  const {
    isLoading: articlesLoading,
    data: articles,
    isLoadingError: articlesLoadingError,
  } = useQuery([loadArticles.name, petProfile.petType.id], loadArticles, {
    enabled: !isSpecialtyPet,
    retry: retryCount,
  });

  const {
    isLoading: specialtyPetsArticlesLoading,
    data: specialtyPetsArticles,
    isLoadingError: specialtyPetsArticlesLoadingError,
  } = useQuery([loadSpecialtyArticles.name, petProfile.petType.id], loadSpecialtyArticles, {
    enabled: isSpecialtyPet,
    retry: retryCount,
  });

  return (
    <Articles
      articles={isSpecialtyPet ? specialtyPetsArticles : articles}
      isLoading={isSpecialtyPet ? specialtyPetsArticlesLoading : articlesLoading}
      isSpecialtyPet={isSpecialtyPet}
      isMinLarge={isMinLarge}
      data-testid="pet-articles-slot"
    />
  );
};
